module.exports = __webpack_public_path__ + "media/images/athletes/513-a837d890f429ff94fe5515eeded4fbeb.png";